import React, {useState, useEffect} from 'react';
import ProfileInner from './ProfileInner/ProfileInner';
import {useTranslation} from 'react-i18next';

import {ReactComponent as MenuIcon} from '../../assets/icons/menu.svg';
import './Profile.scss';

const Profile = () => {
  const {t} = useTranslation();

  const [isMenuVisible, setMenuVisible] = useState(false);
  const [isInnerVisible, setInnerVisible] = useState(true);

  const handleNavLinkClick = () => {
    const width = window.innerWidth;

    if (width < 1080) {
      setInnerVisible(true);
      setMenuVisible(false);
    } else {
      setInnerVisible(true);
      setMenuVisible(true);
    }
  };

  useEffect(() => {
    const handleResize = () => {
      const pathSegments = location.pathname.split('/').filter(Boolean);
      const isInnerPage = pathSegments.length > 2 && pathSegments.length <= 3;
      const isNarrowScreen = window.innerWidth < 1080;

      if (isInnerPage) {
        setMenuVisible(!isNarrowScreen);
        setInnerVisible(isNarrowScreen ? isNarrowScreen : true);
      } else {
        setMenuVisible(false);
        setInnerVisible(false);
      }
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [location]);

  const toggleMenu = () => {
    setMenuVisible(true);
    setInnerVisible(false);
  };

  const toggleYourContent = () => {
    setMenuVisible(false);
    setInnerVisible(false);
  };

  return (
    <div className='page profile-page'>
      {!isMenuVisible && (
        <div className='hidden-menu'>
          <div className='hidden-menu__menu' onClick={toggleMenu}>
            <MenuIcon />
            {t('profile.menu')}
          </div>
        </div>
      )}

      <ProfileInner
        toggleYourContent={toggleYourContent}
        handleNavLinkClick={handleNavLinkClick}
        isMenuVisible={isMenuVisible}
        isInnerVisible={isInnerVisible}
      />
    </div>
  );
};

export default Profile;
